import { api, API } from "./api";

function parseFilenameFromDisposition(headerValue, fallback) {
  if (!headerValue) return fallback;
  const match = /filename="([^"]+)"/i.exec(headerValue);
  return match?.[1] || fallback;
}

/** Extrait le message d'erreur API (y compris quand responseType est blob). */
export async function parseApiErrorDetail(err) {
  const data = err?.response?.data;
  if (!data) return null;
  if (typeof data === "string") return data;
  if (data instanceof Blob) {
    try {
      const text = await data.text();
      try {
        const parsed = JSON.parse(text);
        return parsed.detail || parsed.message || text;
      } catch {
        return text || null;
      }
    } catch {
      return null;
    }
  }
  return data.detail || data.message || null;
}

/** Lien public signé (partage équipe — ouvre un lecteur vidéo sans compte admin). */
export async function fetchSessionVideoPublicUrl(sessionId, variant = "composite") {
  const { data } = await api.get(`/admin/sessions/${sessionId}/video/public-url`, {
    params: { variant },
  });
  return data?.publicUrl || null;
}

export function buildPublicVideoStreamUrl(sessionId, sig, variant = "composite") {
  const params = new URLSearchParams({ variant, sig, media: "1" });
  const path = `${API}/public/sessions/${encodeURIComponent(sessionId)}/video?${params}`;
  if (path.startsWith("http")) return path;
  if (typeof window !== "undefined") {
    return `${window.location.origin}${path}`;
  }
  return path;
}

export async function copyAdminSessionVideoUrl(sessionId, variant = "composite") {
  const url = await fetchSessionVideoPublicUrl(sessionId, variant);
  if (!url) {
    throw new Error("Lien public indisponible");
  }
  if (!navigator.clipboard?.writeText) {
    throw new Error("Presse-papiers indisponible");
  }
  await navigator.clipboard.writeText(url);
  return url;
}

/** Charge une vidéo admin via cookie de session NCB. */
export async function fetchAdminSessionVideo(sessionId, options = {}) {
  return api.get(`/admin/sessions/${sessionId}/video`, {
    params: {
      variant: options.variant || "camera",
      download: options.download ? "true" : undefined,
    },
    responseType: "blob",
  });
}

/** Déclenche un téléchargement sans exposer de jeton dans l’URL. */
export async function downloadAdminSessionVideo(session, variant) {
  const suffix = variant === "composite" ? "-plateau" : "-camera";
  const { data, headers } = await fetchAdminSessionVideo(session.id, {
    variant,
    download: true,
  });
  const ext = (session.video_composite_content_type || session.video_content_type || "video/webm")
    .split("/")
    .pop()
    ?.replace("webm", "webm") || "webm";
  const fallback = `${session.code || "session"}${suffix}.webm`;
  const filename = parseFilenameFromDisposition(headers["content-disposition"], fallback);
  const url = URL.createObjectURL(data);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename.endsWith(`.${ext}`) ? filename : `${filename.split(".")[0]}.${ext}`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
